import "./App.css";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import Home from "./views/Home/home";
import MapView from "./views/Map/map";
import Insurance from "./views/insurance/insurance";

function App() {
  return (
    <BrowserRouter basename="/drugstore">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/map" element={<MapView />} />
        <Route path="/insurance" element={<Insurance />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
